export default __webpack_public_path__ + "static/hq15-b00fdff98a95fdf26b3b726943f389f0.jpg";